import { Injectable } from '@angular/core';
import { Config, StoreService } from '@ddt-web/store-service';
import * as get from 'lodash/get';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { AppConfigApiService } from './app-config-api.service';

@Injectable({ providedIn: 'root' })
export class AppConfigService {
	constructor(private storeService: StoreService, private appConfigApiService: AppConfigApiService) { }

	public hasTool<T>(config: Config<T>, toolName: string): Observable<boolean> {
		return this.storeService.selectAll(config).pipe(map((data: any) => {
			return data.displayConfig.some(toolConfig => toolConfig.toolId === toolName);
		}));
	}

	public hasElement<T>(config: Config<T>, toolName: string, elementId: string): Observable<boolean> {
		return this.storeService.selectAll(config).pipe(map(data => {
			return get(this.getElement(data, toolName, elementId), 'isEnabled', false);
		}));
	}

	public getElementAttributeList<T>(config: Config<T>, toolName: string, elementId: string): Observable<Array<any>> {
		return this.storeService.selectAll(config).pipe(map(data => {
			return get(this.getElement(data, toolName, elementId), 'attributes', []);
		}));
	}

	private getElement(data: {}, toolName: string, elementId: string): {} {
		const appConfig = data['displayConfig'].find(tool => tool.toolId === toolName);

		const elementConfig = get(appConfig, 'propertyConfigList', []).find(property => property.id === elementId);

		return elementConfig;
	}

	public fetchAppConfigData(): void {
		// TODO: Remove after ACServer /config/get-display code has been released.
		const configData = {
			'displayConfig': [
				{ 'toolId': 'portfolio-analyser', 'propertyConfigList': [{ 'id': 'client-report', 'isEnabled': true }] },
				{ 'toolId': 'scenario-tester', 'propertyConfigList': [{ 'id': 'client-report', 'isEnabled': true }] }
			]
		};
		this.storeService.loadOne({ name: 'appConfig', storeAsList: false, defaultValue: {} }, configData);

		// TODO: Uncomment after ACServer /config/get-display code has been released.
		// this.appConfigApiService.fetchAppConfigData().pipe(first()).subscribe(responseJson => {
		// 	this.storeService.loadOne({ name: 'appConfig', storeAsList: false, defaultValue: {} }, responseJson);
		// });
	}
}
